import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function getSimulador(
  sponsorshipGC,
  activeConsultantsGC,
  leadersGC,
  sponsorshipPL,
  activeConsultantsPL,
  leadersPL,
) {
  let response = {};
  const kit = getCookie('_cs');

  await superagent
    .get(
      `${webservice}/getSimulador?usuarioOK=${kit}&porcientoPatrocinio=${sponsorshipGC}&consultorasActivasGC=${activeConsultantsGC}&lideres1aLinea=${leadersGC}&gpM1=0&gpM2=0&gpM3=0&gpM4=0&gpM5=0&gpM6=0&gpM7=0&gpM8=0&gpM9=0&gpM10=0&gpM11=0&gpM12=0&PL_porcientoPatrocinio=${sponsorshipPL}&PL_consultorasActivasGC=${activeConsultantsPL}&PL_lideres1aLinea=${leadersPL}&PL_gpM1=0&PL_gpM2=0&PL_gpM3=0&PL_gpM4=0&PL_gpM5=0&PL_gpM6=0&PL_gpM7=0&PL_gpM8=0&PL_gpM9=0&PL_gpM10=0&PL_gpM11=0&PL_gpM12=0`,
    )
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .set('Content-Type', 'application/json')
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      console.log(err);
    });

  return response;
}
